import React from 'react';
import '../styles/ImageCollage.css';

const ImageCollage = ({ images }) => {
  return (
    <div className="collage-container">
         <img src={images}  className="collage-image" />
      {/* {images.map((src, index) => (
        <img key={index} src={src} alt={`collage-${index}`} className="collage-image" />
      ))} */}
    </div>
  );
};

export default ImageCollage;